import { lazy } from 'react';

import { type RouteComponentProps } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import messages from './messages'
import { PurchaseOrderListPageTabStatuses } from './PurchaseOrderListPage'

export interface PurchaseOrderRevisePoPageParams {
  uuid: uuid
}

const PurchaseOrderRevisePoViewChunk = lazy(() =>
  import('../containers/PurchaseOrderRevisePoView').then(
    ({ PurchaseOrderRevisePoView }) => ({
      default: PurchaseOrderRevisePoView,
    })
  )
)

export const PurchaseOrderRevisePoPage = ({
  match,
}: RouteComponentProps<PurchaseOrderRevisePoPageParams>) => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.purchaseOrderListPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.purchaseOrderListPageTitle),
          link: url('PurchaseOrderListPage', {
            status: PurchaseOrderListPageTabStatuses.OPEN,
          }),
        },
        {
          name: intl.formatMessage(messages.purchaseOrderDetailsPageTitle),
          link: url('PurchaseOrderDetailsPage', { uuid: match.params.uuid }),
        },
        {
          name: intl.formatMessage(messages.purchaseOrderRevisePoPageTitle),
        },
      ]}
    >
      <PurchaseOrderRevisePoViewChunk />
    </Page>
  )
}
